var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import uuid from 'uuid';
import { apiGetListProffitSearchSlideLikeness } from '../../../../actions/ProffitSearchSlideActions';
import { wrapDispatch } from '../../../action';
/**
 * 表示中スライドの状態に応じて、類似するスライドを取得して返すuse
 * @param slideId
 * @param tags
 * @param dispatch
 * @param unmountRef
 * @returns {{list: *[], loading: boolean}}
 */
export const useSlideSearchOneSlideLikeness = (slideId, tags, dispatch, unmountRef) => {
    const apiRef = useRef();
    const [loading, changeLoading] = useState(false);
    const [slides, changeSlides] = useState({});
    const slidesRef = useRef({});
    slidesRef.current = slides;
    const likeKeys = useMemo(() => {
        const tagJoin = tags.map((v) => v.id).join(',');
        return {
            key: `${slideId}_${tagJoin}`,
            slideId,
            tags: tagJoin,
        };
    }, [slideId, tags]);
    /**
     * 検索APIを実行
     * @type {(function(*=, *, *=): Promise<unknown>)|*}
     */
    const loadLikenessSlides = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (slidesRef.current[likeKeys.key]) {
            return;
        }
        const apiId = uuid();
        apiRef.current = apiId;
        changeLoading(true);
        try {
            const { payload: { list }, } = yield wrapDispatch(dispatch, apiGetListProffitSearchSlideLikeness(likeKeys.slideId, likeKeys.tags));
            // 最後に実行されたAPIの結果で更新する
            if (apiRef.current === apiId && !unmountRef.current) {
                changeSlides((prevState) => (Object.assign(Object.assign({}, prevState), { [likeKeys.key]: list })));
            }
        }
        finally {
            // 最後に実行されたAPIの結果で更新する
            if (apiRef.current === apiId && !unmountRef.current) {
                changeLoading(false);
            }
        }
    }), [
        likeKeys.slideId,
        likeKeys.key,
        likeKeys.tags,
        apiRef,
        changeSlides,
        dispatch,
        unmountRef,
    ]);
    useEffect(() => {
        // 表示中のslideに対応する類似スライドが未取得の場合にAPI実行する
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield loadLikenessSlides();
        }))();
    }, [loadLikenessSlides]);
    return {
        list: slides[likeKeys.key] || [],
        loading,
    };
};
export const useSlideSearchSlideLikeness = {
    useSlideSearchOneSlideLikeness,
};
